export default {
	0: 'left top',
	1: 'right top',
	2: 'left bottom',
	3: 'right bottom',
};
